<!-- <!DOCTYPE html>
<html lang="en"> -->
<!-- 
<head>
    <meta charset="UTF-8">
    <title>Modern Web Design</title>
    <meta name="viewport" content="width=device-width, initial-scale=1">

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">

    <link href="./style.css" rel="stylesheet">

    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css">
</head> -->

<!-- <body> -->

<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-dark position-absolute w-100 my-lg-4">
    <div class="container">

        <a class="navbar-brand fw-bold" href="#">
            <img src="https://whiterobecdns.com/wr-logos/r2_o.svg" width="200" alt="">
        </a>
        <button class="navbar-toggler " type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse nav-cutom-menu pb-3" id="navbarNav">
            <ul class="navbar-nav align-items-center justify-content-center">
                <li class="nav-item"><a class="nav-link" href="#">Home</a></li>
                <li class="nav-item"><a class="nav-link" href="#">About</a></li>
                <li class="nav-item"><a class="nav-link" href="#">Services</a></li>
                <li class="nav-item"><a class="nav-link" href="#">Portfolio</a></li>
                <li class="nav-item"><a class="nav-link" href="#">Contact</a></li>
            </ul>

            <a class="btn btn-gradient " href="#">Get&nbsp;Started</a>
        </div>

    </div>
</nav>

<!-- Hero Section with Carousel -->
<section class="hero-section">
    <div class="container">
        <div id="heroCarousel" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">

                <!-- Slide 1 -->
                <div class="carousel-item active">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>Beautiful & Modern Web Design</h1>
                            <p>Crafting visually stunning and highly functional websites that captivate and convert
                                visitors.</p>
                            <a href="#" class="btn btn-gradient mt-3">Learn More</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/banner-res-img1.png" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

                <!-- Slide 2 -->
                <div class="carousel-item">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>Creative Digital Solutions</h1>
                            <p>We build modern and scalable digital experiences for startups and enterprises.</p>
                            <a href="#" class="btn btn-gradient mt-3">Explore Now</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/banner-res-img1.png" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

            </div>

            <!-- Controls -->
            <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
                <span class="carousel-control-next-icon"></span>
            </button>

        </div>
    </div>
</section>

<section class="stats-section shadow-sm">
    <div class="container">
        <div class="row text-center g-4">

            <div class="col-lg-3 col-md-6" *ngFor="let stat of stats">
                <div class="stat-box">
                    <div class="stat-icon" [ngClass]="stat.color">
                        <i class="bi" [ngClass]="stat.icon"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>{{ stat.displayValue | number }}+</h3>
                        <p>{{ stat.label }}</p>
                    </div>
                </div>
            </div>

           
            <!-- <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon purple">
                        <i class="bi bi-briefcase-fill"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>10K+</h3>
                        <p>Jobs Posted</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon orange">
                        <i class="bi bi-envelope-fill"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>2K+</h3>
                        <p>Companies Hiring</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon blue">
                        <i class="bi bi-check-circle-fill"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>95%</h3>
                        <p>Success Rate</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon violet">
                        <i class="bi bi-globe"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>25</h3>
                        <p>Countries</p>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</section>

<section class="jobs-wrapper">
    <div class="container">
        <h2 class="jobs-heading">Featured Jobs</h2>

        <div class="row g-4">

            <!-- Job Card 1 -->
            <div class="col-lg-4 col-md-6" *ngFor="let j of jobsList | slice:0:3">
                <div class="career-card">
                    <div class="job-top">
                        <img [src]="getAvatarImageUrl(j)" class="job-avatar">

                        <div>
                            <p class="job-title">{{j.job_title}}</p>
                            <p class="job-company">{{j.companyDetails.company_name}}</p>
                        </div>
                    </div>
                    <p class="job-info"><i class="bi bi-geo-alt"></i> {{ getCommaSeparatedLocations(j) }} • {{
                        formatSalary(j) }}</p>
                    <div class="text-end">
                        <button class="apply-btn-custom" (click)="goToJob(j)">Apply Now</button>
                    </div>
                </div>
            </div>

            <!-- Job Card 2 -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="career-card">
                    <div class="job-top">
                        <img src="https://randomuser.me/api/portraits/women/44.jpg" class="job-avatar">
                        <div>
                            <p class="job-title">Marketing Specialist</p>
                            <p class="job-company">CreativeHub</p>
                        </div>
                    </div>
                    <p class="job-info"><i class="bi bi-geo-alt"></i> San Francisco, CA • $60K - $75K/yr</p>
                    <div class="text-end">
                        <button class="apply-btn-custom">Apply Now</button>
                    </div>
                </div>
            </div> -->

            <!-- Job Card 3 -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="career-card">
                    <div class="job-top">
                        <img src="https://randomuser.me/api/portraits/men/75.jpg" class="job-avatar">
                        <div>
                            <p class="job-title">Software Engineer</p>
                            <p class="job-company">Innovatech</p>
                        </div>
                    </div>
                    <p class="job-info"><i class="bi bi-geo-alt"></i> Austin, TX • $90K - $110K/yr • Full-Time</p>
                    <div class="text-end">
                        <button class="apply-btn-custom">Apply Now</button>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</section>

<section class="category-zone">
    <div class="container">
        <h2 class="category-title">Explore by Category</h2>

        <div class="row g-4">

            <!-- Technology -->
            <div class="col-lg-20 col-md-4 col-6">
                <div class="category-box bg-tech">
                    <div class="category-icon icon-tech">
                        <i class="bi bi-laptop"></i>
                    </div>
                    <div>
                        <p class="cat-name">Technology</p>
                        <p class="cat-count">1,250 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Marketing -->
            <div class="col-lg-20 col-md-4 col-6">
                <div class="category-box bg-market">
                    <div class="category-icon icon-market">
                        <i class="bi bi-megaphone"></i>
                    </div>
                    <div>
                        <p class="cat-name">Marketing</p>
                        <p class="cat-count">980 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Healthcare -->
            <div class="col-lg-20 col-md-4 col-6">
                <div class="category-box bg-health">
                    <div class="category-icon icon-health">
                        <i class="bi bi-suit-heart"></i>
                    </div>
                    <div>
                        <p class="cat-name">Healthcare</p>
                        <p class="cat-count">800 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Finance -->
            <div class="col-lg-20 col-md-4 col-6">
                <div class="category-box bg-finance">
                    <div class="category-icon icon-finance">
                        <i class="bi bi-currency-rupee"></i>
                    </div>
                    <div>
                        <p class="cat-name">Finance</p>
                        <p class="cat-count">760 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Remote Work -->
            <div class="col-lg-20 col-md-4 col-6">
                <div class="category-box bg-remote">
                    <div class="category-icon icon-remote">
                        <i class="bi bi-cast"></i>
                    </div>
                    <div>
                        <p class="cat-name">Remote Work</p>
                        <p class="cat-count">1,100 Jobs</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="process-area">
    <div class="container">
        <h2 class="process-title">How It Works</h2>

        <div class="row g-4">

            <!-- Step 1 -->
            <div class="col-lg-4 col-md-6">
                <div class="step-card-box">
                    <div class="step-badge">1</div>
                    <div>
                        <h5 class="step-heading">Create Profile</h5>
                        <p class="step-text">Sign up and set up your profile.</p>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="col-lg-4 col-md-6">
                <div class="step-card-box">
                    <div class="step-badge">2</div>
                    <div>
                        <h5 class="step-heading">Search Jobs</h5>
                        <p class="step-text">Find the perfect job that suits you.</p>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="col-lg-4 col-md-6">
                <div class="step-card-box">
                    <div class="step-badge">3</div>
                    <div>
                        <h5 class="step-heading">Apply & Get Hired</h5>
                        <p class="step-text">Submit your application and get hired.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="brand-showcase-area">
    <div class="container">
        <h2 class="brand-heading">Featured Companies</h2>

        <div class="brand-logo-wrap">
            <div class="brand-item">
                <img src="https://static.wikia.nocookie.net/windows/images/3/33/Microsoft-logo.png/revision/latest?cb=20231201023319"
                    alt="Microsoft">
            </div>


            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/3840px-Amazon_logo.svg.png"
                    alt="Amazon">
            </div>

            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/69/Airbnb_Logo_Bélo.svg" alt="Airbnb">
            </div>

            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" alt="Google">
            </div>
            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" alt="Google">
            </div>

            <div class="brand-item">
                <img src="https://cdn.worldvectorlogo.com/logos/spotify-logo.svg" alt="Microsoft">
            </div>

        </div>
    </div>
</section>

<section class="feedback-zone">
    <div class="container">

        <!-- Section Title -->
        <div class="text-center">
            <h2 class="feedback-heading">What Our Users Say</h2>
        </div>

        <!-- Testimonials Row -->
        <div class="row g-4">

            <!-- Card 1 -->
            <div class="col-md-6 col-lg-4">
                <div class="review-card-box">
                    <div class="d-flex align-items-center mb-3">
                        <img src="https://randomuser.me/api/portraits/women/44.jpg" class="client-avatar me-3" alt="">
                        <div>
                            <p class="client-review-text">
                                This platform helped me land my dream job.
                            </p>
                            <div class="star-rating">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                        </div>
                    </div>
                    <h6 class="client-name">Sarah M.</h6>
                    <span class="client-role">Marketing Manager</span>
                </div>
            </div>

            <!-- Card 2 -->
            <div class="col-md-6 col-lg-4">
                <div class="review-card-box">
                    <div class="d-flex align-items-center mb-3">
                        <img src="https://randomuser.me/api/portraits/men/32.jpg" class="client-avatar me-3" alt="">
                        <div>
                            <p class="client-review-text">
                                Amazing experience and great opportunities.
                            </p>
                            <div class="star-rating">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                        </div>
                    </div>
                    <h6 class="client-name">James R.</h6>
                    <span class="client-role">Software Engineer</span>
                </div>
            </div>

            <!-- Card 3 -->
            <div class="col-md-6 col-lg-4">
                <div class="review-card-box">
                    <div class="d-flex align-items-center mb-3">
                        <img src="https://randomuser.me/api/portraits/women/68.jpg" class="client-avatar me-3" alt="">
                        <div>
                            <p class="client-review-text">
                                I found my perfect job in just a few days!
                            </p>
                            <div class="star-rating">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                        </div>
                    </div>
                    <h6 class="client-name">Emily T.</h6>
                    <span class="client-role">UI/UX Designer</span>
                </div>
            </div>

        </div>

        <!-- Subscribe Button -->
        <div class="text-center mt-5">
            <button class="cta-subscribe-btn">
                Subscribe Now <i class="bi bi-arrow-right ms-2"></i>
            </button>
        </div>

    </div>
</section>

<footer class="site-footer-area">
    <div class="container">

        <div class="row">

            <!-- Column 1 -->
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">About Us</h5>
                <a href="#" class="footer-link-item">About UA</a>
                <a href="#" class="footer-link-item">Contact</a>
                <a href="#" class="footer-link-item">Connect Us</a>
                <a href="#" class="footer-link-item">Blog</a>
            </div>

            <!-- Column 2 -->
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">For Candidates</h5>
                <a href="#" class="footer-link-item">Browse Jobs</a>
                <a href="#" class="footer-link-item">Jobs Near Me</a>
                <a href="#" class="footer-link-item">Remote Jobs</a>
                <a href="#" class="footer-link-item">Match Jobs</a>
            </div>

            <!-- Column 3 -->
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">For Employers</h5>
                <a href="#" class="footer-link-item">Post Jobs</a>
                <a href="#" class="footer-link-item">Browse Resumes</a>
                <a href="#" class="footer-link-item">Hire Now</a>
            </div>

            <!-- Column 4 -->
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">Support</h5>
                <a href="#" class="footer-link-item">Candidate Help</a>
                <a href="#" class="footer-link-item">Employer Help</a>
                <a href="#" class="footer-link-item">Blog Center</a>

                <div class="social-icons-group mt-3">
                    <a href="#"><i class="bi bi-facebook"></i></a>
                    <a href="#"><i class="bi bi-twitter"></i></a>
                    <a href="#"><i class="bi bi-instagram"></i></a>
                    <a href="#"><i class="bi bi-linkedin"></i></a>
                </div>
            </div>

        </div>

        <!-- Bottom -->
        <div class="footer-bottom-text">
            © 2024 JobFinder. All rights reserved.
        </div>

    </div>
</footer>

<!-- Bootstrap JS -->
<!-- <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script> -->

<!-- </body>

</html> -->